<template>

  <component :is="layout">
    <nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
      <div class="container-fluid">
        <a class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block" href="#">
          <i class="far fa-money-bill-alt"></i> {{ $i18n.t('global.books') }}
        </a>

        <ul class="navbar-nav align-items-center d-none d-md-flex">
          <li class="nav-item dropdown">
            <a class="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="media align-items-center">
                <span v-if="user" class="photoURL avatar avatar-sm rounded-circle" :style="{ 'background-image': 'url('+user.photoURL+')' }">
                </span>
                <div class="media-body ml-2 d-none d-lg-block">
                  <span class="mb-0 text-sm  font-weight-bold">{{ user ? user.displayName : '' }}</span>
                </div>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
              <Menu key="Book" />
            </div>
          </li>
        </ul>

      </div>
    </nav>

    <div class="header bg-gradient-primary pb-7 pt-5 pt-md-6"></div>

    <div class="container-fluid mt--7" v-if="book">

      <div class="row mt-5">
        <div class="col-lg-12 order-xl-2 mb-5 mb-xl-0">
          <div class="card card-profile shadow">
            <div class="card-header text-center border-0 pt-4 pt-md-4 pb-4 pb-md-4">
              <div class="d-flex justify-content-between">
                <button @click="$router.replace({ name: 'book' })" class="btn btn-sm btn-info mr-4">
                  <i class="fas fa-angle-left"></i> {{ $i18n.t('global.back') }}
                </button>

                <div class="float-right">

                  <button class="btn btn-sm btn-default" data-toggle="modal" data-target="#edit">
                    <i class="fas fa-edit"></i> {{ $i18n.t('global.edit') }}
                  </button>
                  <div class="modal fade" id="edit" tabindex="-1" role="dialog" :aria-labelledby="book.name" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLabel">{{ $i18n.t('books.edit') }}</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-left">
                          <div class="form-group focused">
                            <label for="name" class="form-control-label">{{ $i18n.t('global.book') }}</label>
                            <input v-model="bookEdit" type="text" class="form-control form-control-alternative">
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $i18n.t('global.close') }}</button>
                          <button @click="updateBook()" class="btn btn-primary">{{ $i18n.t('global.save') }}</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button type="button" data-toggle="modal" data-target="#delete" class="btn btn-sm btn-danger">
                    <i class="fas fa-trash-alt"></i> {{ $i18n.t('global.delete') }}
                  </button>
                  <div class="modal fade" id="delete" tabindex="-1" role="dialog" :aria-labelledby="book.name" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title">{{ $i18n.t('global.delete') }}</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <p>{{ $i18n.t('books.delete') }}</p>
                          <p class="font-weight-900"><i class="fas fa-exclamation-triangle"></i> {{ $i18n.t('books.delete2') }}</p>
                        </div>
                        <div class="modal-footer">
                          <button class="btn btn-secondary" data-dismiss="modal">{{ $i18n.t('global.no') }}</button>
                          <button @click="deleteBook()" class="btn btn-primary">{{ $i18n.t('global.yes') }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">

              <div class="text-center">
                <h3 class="font-weight-800"> <i>{{ book.name }}</i> </h3>
              </div>
              <div class="row">
                <div class="col">
                  <div class="card-profile-stats d-flex justify-content-center">
                    <div>
                      <span class="heading">{{ book.nbCoins }} <i class="fas fa-coins"></i></span>
                      <span class="description">{{ $i18n.t('global.coins') }}</span>
                    </div>
                    <div>
                      <span class="heading">{{ book.nbBanknotes }} <i class="far fa-money-bill-alt"></i></span>
                      <span class="description">{{ $i18n.t('global.banknotes') }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-4">

                <div class="col-sm-12 col-md-12 col-lg-6 mb-3">

                  <div class="row">
                    <div class="col">
                      <div class="card shadow">
                        <div class="card-header border-0">
                          <h3 class="mb-0">
                            <button style="margin:0 !important" type="button" class="btn btn-primary btn-sm" @click="$router.replace({ name: 'coin.new' })"><i class="fas fa-plus"></i></button>
                            {{ $i18n.t('global.coins') }}
                          </h3>
                          <input v-if="book.coins.length > 0" type="text" v-model="searchCoin" class="form-control form-control-alternative mt-2" :placeholder="$i18n.t('global.search')">
                        </div>
                        <div class="table-responsive" v-if="book.coins.length > 0">
                          <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">{{ $i18n.t('global.coin') }}</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(coin, index) in filteredCoins" :key="coin.key">
                                <th scope="row">
                                  <div class="media align-items-center">
                                    <div class="avatar rounded-circle mr-3">
                                      <img :alt="coin.title" :src="coin.image">
                                    </div>
                                    <div class="media-body">
                                      <span class="mb-0 text-sm">{{ coin.title }}</span> <br>
                                      <small class="mb-0">{{ $i18n.tc('books.coins', coin.quantity) }}</small>
                                    </div>
                                  </div>
                                </th>
                                <td>
                                  <button style="margin:5px 0 0 0 !important" type="button" class="btn btn-primary" @click="$router.replace({ name: 'coin.show', params: { key: coin.key } })">
                                    <i class="far fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-if="book.coins.length > 0" class="card-footer py-4">
                          <nav>
                            <ul class="pagination justify-content-end mb-0">
                              <li class="page-item" :class="{ 'disabled': currentPageCoin == 1 }">
                                <div class="page-link" @click="prevPageCoin">
                                  <i class="fas fa-angle-left"></i>
                                  <span class="sr-only">Previous</span>
                                </div>
                              </li>
                              <li class="page-item" :class="{ 'disabled': (currentPageCoin * pageSizeCoin) >= book.coins.length }">
                                <div class="page-link" @click="nextPageCoin">
                                  <i class="fas fa-angle-right"></i>
                                  <span class="sr-only">Next</span>
                                </div>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="col-sm-12 col-md-12 col-lg-6 mb-3">

                  <div class="row">
                    <div class="col">
                      <div class="card shadow">
                        <div class="card-header border-0">
                          <h3 class="mb-0">
                            <button style="margin:0 !important" type="button" class="btn btn-primary btn-sm" @click="$router.replace({ name: 'banknote.new' })"><i class="fas fa-plus"></i></button>
                            {{ $i18n.t('global.banknotes') }}
                          </h3>
                          <input v-if="book.banknotes.length > 0" type="text" v-model="searchBanknote" class="form-control form-control-alternative mt-2" :placeholder="$i18n.t('global.search')">
                        </div>
                        <div class="table-responsive" v-if="book.banknotes.length > 0">
                          <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">{{ $i18n.t('global.banknote') }}</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(banknote, index) in filteredBanknotes" :key="banknote.key">
                                <th scope="row">
                                  <div class="media align-items-center">
                                    <div class="mr-3">
                                      <img :alt="banknote.title" :src="banknote.image" class="width-100">
                                    </div>
                                    <div class="media-body">
                                      <span class="mb-0 text-sm">{{ banknote.title }}</span> <br>
                                      <small class="mb-0">{{ $i18n.tc('books.banknotes', banknote.quantity) }}</small>
                                    </div>
                                  </div>
                                </th>
                                <td>
                                  <button style="margin:5px 0 0 0 !important" type="button" class="btn btn-primary" @click="$router.replace({ name: 'banknote.show', params: { key: banknote.key } })">
                                    <i class="far fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-if="book.banknotes.length > 0" class="card-footer py-4">
                          <nav>
                            <ul class="pagination justify-content-end mb-0">
                              <li class="page-item" :class="{ 'disabled': currentPageBanknote == 1 }">
                                <div class="page-link" @click="prevPageBanknote">
                                  <i class="fas fa-angle-left"></i>
                                  <span class="sr-only">Previous</span>
                                </div>
                              </li>
                              <li class="page-item" :class="{ 'disabled': (currentPageBanknote * pageSizeBanknote) >= book.banknotes.length }">
                                <div class="page-link" @click="nextPageBanknote">
                                  <i class="fas fa-angle-right"></i>
                                  <span class="sr-only">Next</span>
                                </div>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <Footer />

    </div>
  </component>

</template>

<script>
import Footer from '../../layouts/Footer'
import Modal from '../../layouts/Modal'
import Menu from '../../layouts/Menu'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'BookShow',
  components: { Footer, Modal, Carousel, Slide, Menu },
  data () {
    return {
      bookEdit: '',
      searchCoin: '',
      currentSortCoin: 'coin',
      currentSortDirCoin: 'asc',
      pageSizeCoin: 4,
      currentPageCoin: 1,
      searchBanknote: '',
      currentSortBanknote: 'banknote',
      currentSortDirBanknote: 'asc',
      pageSizeBanknote: 4,
      currentPageBanknote: 1
    }
  },
  computed: {
    layout () {
      return 'Layout'
    },
    user () {
      return this.$store.getters.user
    },
    book () {
      let book = this.$store.getters.book
      this.bookEdit = book ? book.name : ''
      return book
    },
    filteredCoins () {
      if (this.book && this.book.coins) {
        let filtered = this.book.coins.filter(coin => {
          return coin.title.toLowerCase().indexOf(this.searchCoin.toLowerCase()) > -1
        })
        return filtered.sort((a, b) => {
          let modifier = 1
          if (this.currentSortDirCoin === 'desc') modifier = -1
          if (a[this.currentSortCoin] < b[this.currentSortCoin]) return -1 * modifier
          if (a[this.currentSortCoin] > b[this.currentSortCoin]) return 1 * modifier
          return 0
        }).filter((row, index) => {
          let start = (this.currentPageCoin - 1) * this.pageSizeCoin
          let end = this.currentPageCoin * this.pageSizeCoin
          if (index >= start && index < end) return true
        }).sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      }
      return null
    },
    filteredBanknotes () {
      if (this.book && this.book.banknotes) {
        let filtered = this.book.banknotes.filter(banknote => {
          return banknote.title.toLowerCase().indexOf(this.searchBanknote.toLowerCase()) > -1
        })
        return filtered.sort((a, b) => {
          let modifier = 1
          if (this.currentSortDirBanknote === 'desc') modifier = -1
          if (a[this.currentSortBanknote] < b[this.currentSortBanknote]) return -1 * modifier
          if (a[this.currentSortBanknote] > b[this.currentSortBanknote]) return 1 * modifier
          return 0
        }).filter((row, index) => {
          let start = (this.currentPageBanknote - 1) * this.pageSizeBanknote
          let end = this.currentPageBanknote * this.pageSizeBanknote
          if (index >= start && index < end) return true
        }).sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      }
      return null
    }
  },
  created () {
    this.$store.dispatch('fetchUser')
    this.$store.dispatch('fetchBook', { key: this.$route.params.key })
  },
  methods: {
    updateBook () {
      let name = this.bookEdit
      let key = this.$route.params.key
      if (this.user) {
        this.$store.dispatch('updateBook', { name, key }).then(() => {
          window.location.href = '/books/show/' + key
        })
      }
    },
    deleteBook () {
      let key = this.$route.params.key
      if (this.user && this.book) {
        let bookId = this.book.id
        this.$store.dispatch('deleteBook', { key, bookId })
      }
    },
    nextPageCoin () {
      if ((this.currentPageCoin * this.pageSizeCoin) < this.book.coins.length) this.currentPageCoin++
    },
    prevPageCoin () {
      if (this.currentPageCoin > 1) this.currentPageCoin--
    },
    nextPageBanknote () {
      if ((this.currentPageBanknote * this.pageSizeBanknote) < this.book.banknotes.length) this.currentPageBanknote++
    },
    prevPageBanknote () {
      if (this.currentPageBanknote > 1) this.currentPageBanknote--
    }
  }
}
</script>

<style scoped>
  .margin-images {
    display: flex;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  #search { height: 30px; }
  .sort-hover:hover { cursor: pointer; }
  .width-100 { width: 100px; }
</style>



// WEBPACK FOOTER //
// src/components/Book/BookShow.vue